import axios from "axios";
import { OpenAPI } from "@propertelligent/client-api";

/**
 * Thin local client for the per-user notification-preference endpoints
 * (GET/PUT /api/UserNotification/me). Kept out of the generated @propertelligent/client-api
 * so the UI can ship before the backend CI regenerates the SDK. Reuses OpenAPI.BASE/TOKEN
 * so it points at the same origin + JWT as every other call.
 */

export interface NotificationItem {
  key: string;
  label: string;
  description: string;
  enabled: boolean;
}

export interface NotificationGroup {
  group: number;
  groupKey: string;
  groupLabel: string;
  items: NotificationItem[];
}

export interface NotificationSettings {
  groups: NotificationGroup[];
}

export interface NotificationPreference {
  key: string;
  enabled: boolean;
}

export interface SingleItemResponse<T> {
  success?: T;
  errors?: Record<string, string[]>;
}

const baseUrl = (): string => (typeof OpenAPI.BASE === "string" ? OpenAPI.BASE : "");

const authHeaders = (): Record<string, string> => {
  const token = typeof OpenAPI.TOKEN === "string" ? OpenAPI.TOKEN : undefined;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getMyNotificationSettings = async (): Promise<SingleItemResponse<NotificationSettings>> => {
  const res = await axios.get(`${baseUrl()}/api/UserNotification/me`, { headers: authHeaders() });
  return res.data;
};

export const updateMyNotificationSettings = async (
  preferences: NotificationPreference[]
): Promise<SingleItemResponse<NotificationSettings>> => {
  const res = await axios.put(
    `${baseUrl()}/api/UserNotification/me`,
    { preferences },
    { headers: authHeaders() }
  );
  return res.data;
};
